import { render, staticRenderFns } from "./caijian.vue?vue&type=template&id=2f0fb948&scoped=true"
import script from "./caijian.vue?vue&type=script&lang=js"
export * from "./caijian.vue?vue&type=script&lang=js"
import style0 from "./caijian.vue?vue&type=style&index=0&id=2f0fb948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0fb948",
  null
  
)

export default component.exports